module.exports = __webpack_public_path__ + "img/Ahasan.2f73327b.jpg";